import "./license.scss";
(function ($) {
  $(document).ready(function () {
    let endpointBase = "https://bplugins.com/";
    if (location.host === "localhost") {
      endpointBase = "http://localhost/freemius/";
    }
    const app = {
      endpoint: endpointBase + "wp-json/license/v1/gumroad",
      product: ["h5vp", "h5vpp", "cKpNL"],
      gumroadEndpoint: "https://api.gumroad.com/v2/licenses/verify",
      website: h5vpAdmin?.website,
      ajaxUrl: h5vpAdmin?.ajaxUrl,
      email: h5vpAdmin?.email,
    };
    const opener = document.querySelector(".h5vp_licence");
    const activator = document.querySelector(".h5vp_licence_popup");
    const agreedButton = document.querySelector(".h5vp_license_agreed");
    const activeButton = document.querySelector(".h5vp_active_license");
    const deactiveButton = document.querySelector(".h5vp_deactive_license");
    const closer = document.querySelectorAll(".h5vp_closer");

    opener?.addEventListener("click", function (e) {
      e.preventDefault();
      activator.style.display = "block";
    });

    closer.forEach(function (item) {
      item?.addEventListener("click", function (e) {
        activator.style.display = "none";
      });
    });

    agreedButton?.addEventListener("click", function () {
      activeButton.disabled = !agreedButton?.checked;
    });

    activeButton?.addEventListener("click", function (e) {
      e.preventDefault();
      const licenceKeyField = document.querySelector(".h5vp_licence_key");
      if (licenceKeyField.value) {
        activeLicenece(app, licenceKeyField.value);
      } else {
        setNotice("notice-warning", "Please input a licence key");
      }
    });

    deactiveButton?.addEventListener("click", function () {
      const licenceKeyField = document.querySelector(".h5vp_licence_key");
      deactiveLicenece(app, licenceKeyField.value);
    });
  });
})(jQuery);

export function setNotice(classes, noticeText) {
  const noticeParent = document.querySelector(".h5vp_licence_notice");
  const notice = document.createElement("div");
  notice.classList = `notice ${classes}`;
  notice.innerText = noticeText;
  noticeParent.appendChild(notice);
  setTimeout(() => {
    notice.remove();
    if (classes == "notice-success") {
      location.reload();
    }
  }, 3000);

  setTimeout(() => {
    if (classes == "notice-success") {
      location.reload();
    }
  }, 1000);
  return;
}

export async function activeLicenece(app, licenseKey) {
  let response = {};
  let isAppSumo = false;
  try {
    response = await jQuery.ajax({
      url: app.gumroadEndpoint,
      data: {
        product_permalink: app.product[0],
        license_key: licenseKey,
      },
      method: "POST",
    });
  } catch {
    response = {
      success: false,
    };
  }
  if (!response?.success) {
    try {
      response = await jQuery.ajax({
        url: app.gumroadEndpoint,
        data: {
          product_permalink: app.product[1],
          license_key: licenseKey,
        },
        method: "POST",
      });
      isAppSumo = true;
    } catch {
      response = {
        success: false,
      };
    }
  }

  if (!response?.success) {
    try {
      response = await jQuery.ajax({
        url: app.gumroadEndpoint,
        data: {
          product_permalink: app.product[2],
          license_key: licenseKey,
        },
        method: "POST",
      });
      isAppSumo = true;
    } catch {
      return setNotice("notice-error", "Please input a Valid licence key");
    }
  }

  if (response?.success) {
    let quantity = 1;
    if (response?.purchase?.variants === "(5 Sites)") {
      quantity = 5;
    } else if (response?.purchase?.variants === "( 3 Sites)") {
      quantity = 3;
    } else if (response?.purchase?.variants === "(Developer)") {
      quantity = 1000;
    } else if (response?.purchase?.variants === "(Single Sites)") {
      quantity = 1;
    }
    jQuery.ajax({
      url: app.endpoint,
      data: {
        license_key: licenseKey,
        quantity: quantity,
        website: app.website,
        product: app.product[0],
        email: app.email,
        isAppSumo,
        action: "add",
      },
      method: "POST",
      success: function (response) {
        if (response?.active) {
          jQuery.ajax({
            url: app?.ajaxUrl,
            data: {
              license_key: licenseKey,
              activated: response?.active,
              action: "h5vp_active_licence_key",
            },
            method: "GET",
            success: function (res) {
              setNotice(response?.class, response?.message);
            },
          });
        } else {
          setNotice(response?.class, response?.message);
        }
      },
      error: function (res) {
        console.log("response", res);
        return setNotice("notice-error", "Somethin went wrong! please try again. failed in ajax");
      },
    });
  } else {
    return setNotice("notice-error", "Please input a Valid licence key");
  }
  return false;
}

/**
 * Deactivate Licence
 * @param {*} app
 * @param {*} licenceKeyField
 */
export async function deactiveLicenece(app, licenseKey) {
  let response = {};
  try {
    response = await jQuery.ajax({
      url: app.gumroadEndpoint,
      data: {
        product_permalink: app.product[0],
        license_key: licenseKey,
      },
      method: "POST",
    });
  } catch {
    response = {
      success: true,
    };
  }

  if (!response?.success) {
    try {
      response = await jQuery.ajax({
        url: app.gumroadEndpoint,
        data: {
          product_permalink: app.product[1],
          license_key: licenseKey,
        },
        method: "POST",
      });
    } catch {
      return setNotice("notice-error", "Please input a Valid licence key");
    }
  }

  if (response?.success) {
    jQuery.ajax({
      url: app.endpoint,
      data: {
        license_key: licenseKey,
        website: app.website,
        action: "deactive",
        product: app.product[0],
      },
      method: "POST",
      success: (response) => {
        if (response?.deactive) {
          jQuery.ajax({
            url: app.ajaxUrl,
            data: {
              license_key: "",
              activated: response.active,
              action: "h5vp_active_licence_key",
            },
            method: "GET",
            success: function (res) {
              if (res) {
                setNotice(response?.class, response?.message);
              }
            },
          });
        } else {
          setNotice(response?.class, response?.message);
        }
      },
      error: (err) => {
        setNotice("notice-error", "Sorry, Plugin deactivation failed!");
      },
    });
  } else {
    return setNotice("notice-error", "Please input a Valid licence key");
  }
  return false;
}
